<template>
  <div class="main">
    <div class="auto-box">
      <div class="user">
        <img :src="userinfo.imageUrl" class="avatar" />
        <div class="user-right">
          <div class="user-info">
            <span class="name">{{ name ? name : phone }}</span>
            <span class="tag" :class="{ 'active-tag': userStatus }">
              {{ userStatus ? "已认证" : "未认证" }}</span
            >
          </div>

          <div class="course-time">
            <span style="margin-right: 50px"
              >课程：<span class="font-b">{{ today }} </span> 分钟</span
            >
            <span
              >累计学习：<span class="font-b">{{ total }} </span> 小时</span
            >
          </div>
        </div>
      </div>
      <div class="menu">
        <!-- <div
        class="item"
        :class="curMenu == 'Study' ? 'act' : ''"
        @click="pathAct('Study')"
      >
        学习中心
      </div> -->
        <div
          class="item"
          :class="curMenu == 'Learn' ? 'act' : ''"
          @click="pathAct('Learn')"
        >
          我的课程
        </div>
        <div
          class="item"
          :class="curMenu == 'MyPro' ? 'act' : ''"
          @click="pathAct('MyPro')"
          v-if="!isSimple"
        >
          我的项目
        </div>
        <div
          class="item"
          :class="curMenu == 'Message' ? 'act' : ''"
          @click="pathAct('Message')"
          v-if="!isSimple"
        >
          消息中心
        </div>
        <div
          class="item"
          :class="curMenu == 'MyCertificate' ? 'act' : ''"
          @click="pathAct('MyCertificate')"
        >
          我的证书
        </div>
        <div
          class="item"
          :class="curMenu == 'Collection' ? 'act' : ''"
          @click="pathAct('Collection')"
        >
          我的收藏
        </div>
        <div
          class="item"
          :class="curMenu == 'Account' ? 'act' : ''"
          @click="pathAct('Account')"
        >
          账号设置
        </div>
        <div
          class="item"
          :class="curMenu == 'RenZheng' ? 'act' : ''"
          @click="pathAct('RenZheng')"
        >
          账号认证
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { studyTime } from "@/api/other";
import { defineComponent, computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { onBeforeRouteUpdate } from "vue-router";
export default defineComponent({
  setup() {
    let curMenu = ref("Study");
    let showQr = ref(false);
    const router = useRouter();
    const pathAct = (key) => {
      router.push(key);
    };
    const store = useStore();
    const userinfo = computed(() => store.state.user.userinfo);
    console.log(userinfo, "userinfo");
    let userStatus = ref("");
    let name = ref("");
    let phone = ref("");
    userStatus.value = userinfo?.value?.userStatusFlag;
    name.value = userinfo?.value?.name;
    let oriPhone = userinfo?.value?.phone;
    phone.value = oriPhone ? oriPhone.split("").fill("*", 3, 7).join("") : "";
    // 简版个人中心
    const isSimple = ref(sessionStorage.getItem("isSimple"));

    onMounted(() => {
      curMenu.value = router.currentRoute.value?.name;
      getTime();
    });
    onBeforeRouteUpdate((to) => {
      curMenu.value = to.name;
      userStatus.value = userinfo?.value?.userStatusFlag;
      name.value = userinfo?.value?.name;
    });
    let today = ref(0);
    let total = ref(0);
    const getTime = () => {
      studyTime().then((res) => {
        today.value = res.results.todayViewTime
          ? (res.results.todayViewTime / 60).toFixed(1)
          : 0;
        total.value = res.results.totalActualViewTime
          ? (res.results.totalActualViewTime / 3600).toFixed(1)
          : 0;
      });
    };

    return {
      curMenu,
      pathAct,
      userStatus,
      name,
      phone,
      showQr,
      getTime,
      today,
      total,
      // toBxbHome,
      isSimple,
      userinfo,
    };
  },
});
</script>

<style scoped lang="less">
.main {
  background: #ffffff;
  .user {
    height: 100px;
    display: flex;
    align-items: center;
    background-color: #fff;
    .name {
      margin-right: 6px;
    }
    .avatar {
      width: 61px;
      height: 61px;
    }
    .user-right {
      height: 61px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 20px;
      padding: 2px 0;
      .course-time {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
        .font-b {
          font-size: 16px;
          font-weight: 900;
          color: #333333;
        }
      }
    }
    .tag {
      display: inline-block;
      width: 44px;
      height: 18px;
      border-radius: 2px;
      font-size: 12px;
      font-weight: 400;
      color: #bb3b3b;
      background: #ffe4e4;
      line-height: 17px;
      text-align: center;
    }
    .active-tag {
      color: #254ef4;
      background: #d5ddff;
    }
  }
  .menu {
    display: flex;
    background-color: #fff;
    .item {
      margin-right: 107px;
      padding: 14px 0;
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      line-height: 22px;
      cursor: pointer;
    }

    .item.act {
      border-bottom: 4px solid #254ef4;
      color: #254ef4;
    }
  }
}
</style>
